export type PaneType =
  | 'artist'
  | 'playlist'
  | 'track'
  | 'briefList'
  | 'searchResults'
  | 'threads'
  | 'sectionList'
export const ARTIST_PANE = 'artist'
export const PLAYLIST_PANE = 'playlist'
export const TRACK_PANE = 'track'
export const SEARCH_RESULTS_PANE = 'searchResults'
export const SECTION_LIST_PANE = 'sectionList'
export const BRIEF_LIST_PANE = 'briefList'
// GROUP_PANE is for inboxes/channels/libraries/briefs (frontend-only)
// it has pane.type 'searchResults' but also has groupId
export const GROUP_PANE = 'GROUP_PANE'
